<template>
  <v-autocomplete
    :items="items"
    item-text="name"
    item-value="code"
    v-model="model"
    :label="label"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import { countries } from "@/utils/country.js";
export default {
  data() {
    return {
      model: this.value,
      items: countries
    };
  },
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value() {
      this.model = this.value;
    },
    model() {
      this.$emit("input", this.model);
    }
  }
};
</script>

<style>
</style>